import React from 'react';
import Button from '../ui/Button';
import AnimatedSection from '../ui/AnimatedSection';

interface CTABandProps {
    headline: string;
    subheadline: string;
    buttonText: string;
    buttonLink: string;
    isPrimary?: boolean;
}

const CTABand: React.FC<CTABandProps> = ({ headline, subheadline, buttonText, buttonLink, isPrimary = false }) => {
    const backgroundStyle = isPrimary 
        ? { background: 'linear-gradient(145deg, rgba(205,175,42,0.1), rgba(20,20,24,0.9))' }
        : {};

    const borderStyle = isPrimary ? 'border border-yellow-400/30' : '';
    
    return (
        <AnimatedSection>
            <div className="py-24">
                <div className="mx-auto max-w-7xl px-6">
                    <div className={`relative overflow-hidden flex flex-col items-center text-center justify-between gap-8 rounded-3xl p-12 shadow-card shadow-yellow-400/20 ${borderStyle}`}
                        style={backgroundStyle}>
                        <div>
                            <h3 className="text-3xl md:text-4xl font-bold font-serif">{headline}</h3>
                            <p className="mt-3 text-white/80 text-lg max-w-3xl mx-auto">{subheadline}</p>
                        </div>
                        <div className="flex-shrink-0 mt-6">
                            <Button to={buttonLink} variant="primary" className="px-8 py-4 text-lg">
                                {buttonText}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </AnimatedSection>
    );
};

export default CTABand;